import {SnowAttribute, TaskDefinition, WorkflowDefinition} from '@amzn/snow-nxt-workflow-service-typescript-client';
import {AUTO_GENERATED_ENTITY_IDENTIFIERS_WORKFLOW_IDS, CONFIGURE_CNAME_WORKFLOW_REGION} from "src/constants/CommonConstants";
import {getGroupIdByWorkflow} from "src/constants/WorkflowDetails";
import {isTaskSpecificAttribute, isWorkflowSpecificAttribute} from "src/utils/attributeTypeUtils";

export const getWorkflowTaskInputAttributes = (taskDefinitions: TaskDefinition[]): Record<string, SnowAttribute[]> => {
	const taskInputMap: { [key: string]: SnowAttribute[] } = {};

	for (const task of taskDefinitions) {
		taskInputMap[task.taskName || ''] = task.taskInputs || [];
	}

	return taskInputMap;
};

export const getAttributeNames = (taskObjects: TaskDefinition[]): string[] => {
    const attributeNames: string[] = [];

    taskObjects.forEach((task) => {
        if (task.taskInputs) {
            task.taskInputs.forEach((input) => {
                if (input.value === '') {
                    if (isTaskSpecificAttribute(input)) {
                        attributeNames.push(`${task.taskName}.${input.attributeId}`);
                    } else if (isWorkflowSpecificAttribute(input)) {
                        attributeNames.push(input.attributeId || '');
                    }
                }
            });
        }
    });

    return attributeNames;
};

export const buildEntityObject = (taskObjects: TaskDefinition[], input: any, workflowObject: WorkflowDefinition | undefined): Record<string, any> => {
    const entityObject: Record<string, any> = { EntityData: {} };
    taskObjects.forEach((task) => {
        if (task.taskInputs) {
            const taskSpecificData: Record<string, string> = {};

            task.taskInputs.forEach((taskInput) => {
                const { attributeId, value } = taskInput;

                if (value && value.trim() !== '') {
                    return;
                }

                const isWorkflowLevel = isWorkflowSpecificAttribute(taskInput);
                const inputKey = isWorkflowLevel ? attributeId : `${task.taskName}.${attributeId}`;
                const inputValue = input[inputKey || '']?.trim();

                if (isWorkflowLevel) {
                    entityObject.EntityData[attributeId || ''] = inputValue;
                    entityObject[attributeId || ''] = inputValue;
                } else if (isTaskSpecificAttribute(taskInput)) {
                    taskSpecificData[attributeId || ''] = inputValue;
                }
            });

            if (Object.keys(taskSpecificData).length > 0) {
                entityObject[task.taskId || ''] = taskSpecificData;

                Object.keys(taskSpecificData).forEach((attributeId) => {
                    delete entityObject.EntityData[attributeId];
                    delete entityObject[attributeId];
                });
            }

            if (AUTO_GENERATED_ENTITY_IDENTIFIERS_WORKFLOW_IDS.includes(workflowObject?.workflowId as string)) {
                entityObject['Region'] = CONFIGURE_CNAME_WORKFLOW_REGION
                entityObject['EntityType'] = workflowObject?.entityType
                entityObject['EntityName'] = input['EntityName']
            } else {
                entityObject['Region'] = input['Region']
                entityObject['EntityType'] = workflowObject?.entityType
                entityObject['EntityName'] = input['EntityName']
            }
            entityObject['GroupId'] = input[getGroupIdByWorkflow(workflowObject?.workflowId)]
        }
    });

    return entityObject;
};